import GoogleMapApiService from '../../services/GoogleMapApiService';
import googleMapApiUseCase from './googleMapApiUseCase';

const googleMapApiFactory = googleMapApiUseCase({
  GoogleMapApiService: GoogleMapApiService(),
});

export default googleMapApiFactory;
